export default {
  tipoDoc: 'Type of document',
  nroDoc: 'Number of document',
  nombres: 'Names',
  primerAp: 'First lastname',
  segundoAp: 'Second lastname',
  telefono: 'Mobile number',
  email: 'Email',
  nacionalidad: 'Nacionality',
  nro_legalizacion: 'Legalization Number',
  cod_seguridad: 'Security code',
  codigo: 'Tracking code',
  day: 'Day',
  month: 'Month',
  year: 'Year',
  nombre_solicitante: 'Applicant name',
  precio: 'Price',
  estado: 'State',
  fecha_expedicion: 'Date of legalization issuance',
  fecha_nacimiento: 'Birthday',
  fecha_solicitud: 'Date of apply',
  docFactura: 'Number of document',
  tipoFactura: 'Type of document',
  nombreFactura: 'Name',
  det_tramite: 'Details of your procedure',
  info_sol: 'DATA OF THE DOCUMENT HOLDER',
  info_doc: 'DOCUMENT(S)',
  info_doc_adjuntar: 'ATTACH FILE(S)',
  info_pago: 'PAYMENT DATA',
  info_finalizado: 'Finished',
  info_cont: 'Enter your personal information to receive notifications about the status of your procedure',
  info_email: 'Para poder enviar el documento a la apostilla, después de ser legalizado o certificado, debe ingresar una dirección de correo electrónico.',
  info_agregar: 'Add the document(s) you need to legalize or certify',
  alert_doc: 'You must add at least one document.',
  mis_doc: 'My documents',
  total: 'Total',
  agregar: 'Add',
  eliminar: 'Delete',
  costo: 'Price',
  desc_doc: 'Details of the document(s)',
  select_doc: 'Select a document to legalize or certify',
  select_gestion: 'Year of document issuance',
  doc: 'Document',
  docs: 'Documents',
  titulo_factura: 'Enter the information for your voucher',
  datos_pago: 'Check the payment information. The voucher only covers the legalization/certification payment',
  titular_factura: 'Señor(es)',
  costo_doc: 'Costo de documento(s)',
  costo_total: 'Total cost: ',
  costo_legalizacion: 'Costo legalizacion(es)',
  confirmacion_solicitud: 'Are you surethat you want to apply with this information?',
  confirmar: 'Confirm',
  aceptar: 'Agree',
  cancelar: 'Cancel',
  fin_solicitud: 'Your apply was successful!',
  cod_seguimiento: 'Your tracking code is:',
  guardar_codigo: 'Save your tracking code',
  seguimiento_codigo: ' to see the state of your procedure. Enter',
  aqui: '-> HERE',
  ingrese_codigo_seguimiento: 'Enter the tracking code to see the state of your procedure',
  verificar_documento: 'Enter the information to verify that the document is legalized/certified',
  datos_del_solicitante: 'Applicant information',
  pago_entidad: 'Paid in the entity',
  pago_minedu: 'Paid in MINEDU',
  regional: 'Local',
  tipoSolicitud: 'Type of request',
  adjunto: 'Please attach the document that you want to certify',
  motivo: 'Objetive',
  select_departamento: 'Select the department where you carry out your procedure',
  confirmacion_apoderado: 'Are you the holder of the documents to be legalized / certified or is it an attorney?',
  soy_titular: 'I\'M THE OWNER',
  soy_apoderado: 'I AM EMPOWERED',
  espesifique_motivo: 'Please specify the reason',
  adjuntar: 'Drag your file here to begin or click to browse',
  cargando: 'File Uploading ...',
  cargado: 'File Uploaded',
  nota: 'NOTE:',
  nota_contenido: 'Please attach the document you wish to be processed for the following procedures. Your apply is NOT going to be processed if the attachments were not completed',
  nota_contenido_2: 'It is nesessary that you came to our offices, carrying the original documents corresponding to the attachments. Otherwise, the procedure may not have continuity.',
  adjunto_ok: 'File correctly loaded',
  gestion: 'Year',
  tramitador_nroDoc: 'Number of document'
};



// WEBPACK FOOTER //
// ./src/lang/en/fields.js